<base-detail-page  [config]="baseDetailPageConfig" (onLoadedDetail)="onLoadedDetail($event)"></base-detail-page>
<div class="row">
<profile-company [user]="user" [readonly]="true" />
</div>